<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title"> {{ this.translations["headerDistributorRegionMapping"] }}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <form  class="user-actions" novalidate>            
            <section class="example-section">
                <!--
<mat-checkbox *ngFor="let record of rmList; let i = index;" [(ngModel)]="record.Status" [ngModelOptions]="{standalone: true}"  class="example-margin" align="end">
{{ record.Name }}
</mat-checkbox>
-->                     
                <mat-list>
                    <mat-form-field floatPlaceholder="never" class="mr-24"  fxFlex.xs="100" fxFlex="100">                        
                        <input matInput placeholder="{{translations.lblSearchRegion}}" maxlength="25" (input)="onSearchChange($event.target.value)">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </mat-list>
                <mat-selection-list style="width: 98%;" *ngIf="rmList.length > 0">                   
                    <mat-list-option #toggleSelection (click)="selectDeselectAll(regionList,toggleSelection)" class="example-margin" id="toggle" [selected]="toggleValue">{{translations.lblRegionCode}}</mat-list-option>
                </mat-selection-list>
                <mat-selection-list #regionList style="height: calc(27vh); overflow:scroll;">                    
                    <mat-list-option *ngFor="let record of rmList; let i = index;" [selected]="record.Status" (selectionChange)="selectChange($event,record.Name)">
                        {{ record.Name }}
                    </mat-list-option>
                </mat-selection-list>
            </section>  
        </form>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" aria-label="SAVE" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnClose}}
        </button>
    </div>
</div>     


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/distributor-region-form/distributor-region-form.component.html